import { toast } from "react-toastify";
var props = {
	position: "bottom-right",
	autoClose: 5000,
	rtl: false,
};

export const onLangChange = (isRTL) => {
	props.rtl = isRTL;
};

export const toastSuccess = (message) => {
	toast.success(message, props);
};

export const toastError = (message) => {
	if (message) {
		toast.error(message, props);
	} else {
		toast.error("An Error Occured", props);
	}
};
